import Vue from 'vue';
import recipeTransformer from '../../transformers/recipe';
import store from '../../store';

const success = (resolve, response) => {
  const recipe = recipeTransformer.fetch(response.data);
  store.dispatch('fetchAllRecipeProducts', recipe.products);
  resolve();
};

const failed = (errors, reject) => {
  reject(recipeTransformer.fetch(errors));
};

export default (recipeId, data) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`/production/recipe/${recipeId}/product`, {
        product_id: data.product.id,
      })
      .then((response) => {
        success(resolve, response.data);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipe/storeProduct.js